export interface EntityRef {
    key: string;
    label: string;
}

export type Widget = 'text' | 'number' | 'bool' | 'enum' | 'set' | 'fk' | 'json' | 'multiselect';

export interface Field {
    name: string;
    label: string;
    required: boolean;
    comment: string | null;
    readonly: boolean;
    widget: Widget;
    fkTable: string | null;
    options: string[] | null; // enum/set choices
    hidden?: boolean;         // FIELD_META: omit from list + form
    order?: number;           // FIELD_META: presentation order (backend already sorts)
    group?: string | null;    // FIELD_META: optional grouping
}

export interface Option {
    id: string | number;
    label: string;
    swatch?: string | number | null; // packed-RGBA colour for a swatch (e.g. color tones)
}

export type Row = Record<string, string | number | null>;

export interface Meta {
    entity: string;
    table: string;
    pk: string;
    fields: Field[];
    rows: Row[];
    options: Record<string, Option[]>; // keyed by FK target table
    total?: number;                    // unfiltered row count (rows come from the Rows endpoint)
    error?: string;
}

export interface ParentRef {
    field: string;
    table: string;
    entity: string | null; // null = not an editable tab (not navigable)
    id: string | number;
    label: string;
}

export interface ChildRef {
    table: string;
    column: string;
    entity: string | null;
    count: number;
}

export interface References {
    parents: ParentRef[];
    children: ChildRef[];
    error?: string;
}

// Cross-tab navigation target: jump to a row by its pk, or filter a tab by a column value.
export type IncomingFilter =
    | { kind: 'pk'; value: string | number }
    | { kind: 'col'; column: string; value: string | number };

